import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Cool thing Thursday: iA Writer",
  "description": "",
  "published": "2012-11-08T00:00:00.000Z",
  "redirect_from": ["/blog/cool-thing-thursday-ia-writer/swizec/5517"],
  "categories": "Emacs, ia writer, iCloud, IPad, Uncategorized, WriteRoom, Writing",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Having had writing aspirations my whole life - started my first big awesome epic novel that's going to be super awesome and everyone will want to read when I was 9 or 10 - I've gone through many writing tools.`}</p>
    <p><img parentName="p" {...{
        "src": "https://distilleryimage6.s3.amazonaws.com/b5299ee41ef011e2979222000a1e9df0_7.jpg",
        "alt": "Best writing tool",
        "title": "Best writing tool"
      }}></img></p>
    <p>{`First it was notebooks that never got filled beyond the first five pages. Then we got a computer and I used `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/WordPad",
        "title": "WordPad"
      }}>{`WordPad`}</a>{`, which was quickly usurped by `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Microsoft_Word",
        "title": "Microsoft Word"
      }}>{`MS Word`}</a>{` because it was `}<em parentName="p">{`better`}</em>{`.`}</p>
    <p>{`I ended up playing with shiny fonts more than writing. Oh so many shiny fonts! Y'know I used to collect those ...`}</p>
    <p>{`In high school I went back to notebooks, this time I managed to fill them up with terrible prose and even worse poetry. It was writing utopia.`}</p>
    <p>{`The thing about a notebook is that there's nothing else. It's just a notebook. Its purpose in life is providing a big surface that you can scribble upon with your favourite pen. There are no toolbars on the side, no chrome up top, it doesn't even care about the font you're using.`}</p>
    <p>{`A notebook doesn't judge. There's no `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Word_count",
        "title": "Word count"
      }}>{`word count`}</a>{`, no reliable page count, no structure.`}</p>
    <p>{`But notebooks really `}<em parentName="p">{`really`}</em>{` `}<strong parentName="p"><em parentName="strong">{`really`}</em></strong>{`_`}{`_`}{` suck at editing.`}</p>
    <h2 {...{
      "id": "good-writing-on-computers"
    }}>{`Good writing, on computers`}</h2>
    <p>{`A few years ago I discovered `}<a parentName="p" {...{
        "href": "http://www.hogbaysoftware.com/products/writeroom"
      }}>{`WriteRoom`}</a>{`. Oh it was wonderful, finally my writing could cover the whole string and there was nothing to distract me from getting completely lost in the words.`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/11/writeroom-screenshot-1024x640.png",
        "alt": "Writeroom",
        "title": "Writeroom"
      }}></img></p>
    <p>{`After I got bored of the `}<em parentName="p">{`OMG look at my screen! It's so geeky and just like those old terminals! wow`}</em>{` I stopped using WriteRoom and went back to notebooks. Opening it right now almos tmade my eyes bleed. (granted, I have version 2.5.1 and the new one is 3.x.x, things have changed)`}</p>
    <p><a parentName="p" {...{
        "href": "http://swizec.com/blog/stypi-the-perfect-blogging-tool/swizec/3312"
      }}>{`For a while I was using Stypi`}</a>{` and thought that was the best thing since sliced toast prepared by a wonderful female.`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/01/Screen-Shot-2012-01-03-at-4.25.36-PM.png",
        "alt": "My post on Stypi in Stypi",
        "title": "My post on Stypi in Stypi"
      }}></img></p>
    <p>{`Stypi, again, fell into disuses. Not sure why or how, just did. Then I remembered I had iA Writer installed on my `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/IPad",
        "title": "IPad"
      }}>{`iPad`}</a>{`.`}</p>
    <h2 {...{
      "id": "ia-writer"
    }}>{`iA Writer`}</h2>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/11/ia-writer-macos-1024x640.png",
        "alt": "iA Writer on my laptop",
        "title": "iA Writer on my laptop"
      }}></img></p>
    <p>{`iA Writer is one of those tools that is just perfect. It does everything I need and nothing more.`}</p>
    <p>{`When I started writing on `}<a parentName="p" {...{
        "href": "https://leanpub.com/nightowls"
      }}>{`Why programmers work at night`}</a>{` I discovered something interesting - writing in `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Emacs",
        "title": "Emacs"
      }}>{`Emacs`}</a>{` is impossible. It's a wonderful markdown editor, great support, awesome `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Syntax_highlighting",
        "title": "Syntax highlighting"
      }}>{`syntax highlighting`}</a>{`, distractionless coding because there's no toolbars and crap and so on.`}</p>
    <p>{`I love you Emacs, you glorious bastard, but you suck for writing prose.`}</p>
    <p>{`The only place I feel comfortable enough to write is iA Writer. Somewhere between filling up my whole screen with writing, having a super huge font and juuust the perfect kerning and line spacing, iA Writer made me fall in love.`}</p>
    <p>{`Syncing across devices via `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/ICloud",
        "title": "ICloud"
      }}>{`iCloud`}</a>{` or `}<a parentName="p" {...{
        "href": "http://www.crunchbase.com/company/dropbox",
        "title": "Dropbox"
      }}>{`Dropbox`}</a>{` was just icing on the cake.`}</p>
    <p>{`I think my favourite feature is that once you start typing on a bluetooth keyboard all the controls disappear. Your iPad turns into a blank piece of paper and you're going to town on it. Really wonderful.`}</p>
    <p>{`Most importantly I can now write in the same environment in a coffee shop, up on a mountain or at my desk.`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/11/ia-writer-ipad-landscape.png",
        "alt": "iA Writer on the iPad",
        "title": "iA Writer on the iPad"
      }}></img></p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/11/ia-writer-iphone.png",
        "alt": "iA Writer on iPhone",
        "title": "iA Writer on iPhone"
      }}></img><img parentName="p" {...{
        "src": "",
        "alt": null
      }}></img></p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/11/ia-writer-ipad-portrait-clean.png",
        "alt": "iA Writer on iPad once typing begins",
        "title": "iA Writer on iPad once typing begins"
      }}></img></p>
    <h6 {...{
      "id": "related-articles"
    }}>{`Related articles`}</h6>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.tuaw.com/2012/10/31/nanowrimo-tools-for-apple-devices-and-a-few-hot-deals-on-wri/"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/122438801_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://www.tuaw.com/2012/10/31/nanowrimo-tools-for-apple-devices-and-a-few-hot-deals-on-wri/"
        }}>{`NaNoWriMo tools for Apple devices ... and a few hot deals on writing tools`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://notes.envato.com/general/a-truckload-of-desktop-apps-for-writers/"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/111521151_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://notes.envato.com/general/a-truckload-of-desktop-apps-for-writers/"
        }}>{`A Truckload of Desktop Apps for Writers`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://mashable.com/2012/11/06/writing-apps/"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/123900024_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://mashable.com/2012/11/06/writing-apps/"
        }}>{`8 Apps Every Writer and Blogger Should Know`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.wired.com/reviews/2012/09/writing-apps-ipad/"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/115284071_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://www.wired.com/reviews/2012/09/writing-apps-ipad/"
        }}>{`Prose on the iPad: 3 Dedicated Writing Apps`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.hopelesscom.de/2012/8/20/review__ia_writer.html"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/noimg_82_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://www.hopelesscom.de/2012/8/20/review__ia_writer.html"
        }}>{`Review: iA Writer`}</a></li>
    </ul>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/?px",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=a151bf8b-2f3d-433b-8663-89fa885ef83e",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      